<template>
  <!-- Header -->
  <header id="page-header">
    <slot>
      <!-- Header Content -->
      <div class="content-header">
        <!-- Left Section -->
        <div class="d-flex align-items-center">
          <!-- Toggle Mini Sidebar -->
          <base-layout-modifier
            action="sidebarMiniToggle"
            size="sm"
            variant="dual"
            class="mr-2 d-none d-lg-inline-block"
          >
            <i class="fa fa-fw fa-ellipsis-v"></i>
          </base-layout-modifier>
          <!-- END Toggle Mini Sidebar -->
          <!-- Toggle Sidebar -->
          <base-layout-modifier
            action="sidebarToggle"
            size="sm"
            variant="dual"
            class="mr-2 d-lg-none"
          >
            <i class="fa fa-fw fa-bars"></i>
          </base-layout-modifier>
          <!-- END Toggle Sidebar -->
        </div>
        <div class="p-2" v-if="!$route.params.collegeName">
          <b> Welcome, {{ $store.getters.userName }}</b>
          <b-button class="font-size-sm font-w500 ml-4" @click="logout()" 
            >Log Out</b-button
          >
          <!-- END User Dropdown -->
        </div>
        <!-- college logout -->
        <div class="p-2" v-else>
          <b> Welcome, {{ $store.getters.collegeUserName }}</b>
          <b-button class="font-size-sm font-w500 ml-4" @click="logoutCollege()"
            >Log Out</b-button
          >
        </div>
      </div>

      <div
        id="page-header-loader"
        class="overlay-header bg-white"
        :class="{ show: $store.state.settings.headerLoader }"
      >
        <div class="content-header">
          <div class="w-100 text-center">
            <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          </div>
        </div>
      </div>
      <!-- END Header Loader -->
    </slot>
  </header>
  <!-- END Header -->
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      baseSearchTerm: "",
      collegeId: this.$store.getters.collegeCollegeId,
    }
  },
  name: "BaseHeader",
  props: {
    classes: String,
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    async logout() {
      await axios
        .get(`${this.$store.getters.baseUrl}/admin-logout`, {
          headers: { Authorization: `Bearer ${this.$store.getters.token}` },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$store.dispatch("logout")
            this.$router.push("/");
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async logoutCollege() {
      this.collegeId = this.$store.getters.collegeCollegeId;
      console.log("collegeID");
      console.log(this.collegeId);
      await axios
        .get(`${this.$store.getters.baseUrl}/college_logout`, {
          headers: { Authorization: `Bearer ${this.$store.getters.collegeToken}` },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.$store.dispatch("collegeLogout");
            this.$router.push(
              `/college/${this.$route.params.collegeName}/${this.collegeId}/signin`
            );
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
